export default "__VITE_ASSET__BdcjCDrD__"